/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import { BUTTON_COLOR, BUTTON_HEIGHT, BUTTON_WIDTH } from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { CALL_GENERIC_900, PHONE_900, URLS } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      MAX_CARDINALITY_REACHED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Producto ya contratado',
          msg: ['Actualmente ya tienes contratado este producto'],
          errorName: 'producto ya contratado - cardinalidad superada',
        },
      },
      PRODUCT_ALREADY_INCLUDED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Producto ya contratado',
          msg: ['Actualmente ya tienes disponible este producto al estar incluido en otro de tus productos contratados'],
          errorName: 'producto ya incluido en otro',
        },
      },
      OFFER_WITH_SOME_DEPENDENCIES: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: goToC2C ? 'Lo sentimos, no podemos continuar con tu pedido online' : 'Para poder contratar este paquete de TV tienes que hacerlo a través del configurador de miMovistar',
          msg: goToC2C ? [`Ponte en contacto gratis en el ${PHONE_900} y un asesor comercial te ayudará a resolver el problema.`] : [''],
          buttons: [
            goToC2C ? CALL_GENERIC_900 : {
              label: 'Configurar mi pack',
              link: URLS.PACK_CONFIG,
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'oferta con varias dependencias posibles',
        },
      },
      WITHOUT_DEPENDENT_OFFER: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: goToC2C ? 'Lo sentimos, no podemos continuar con tu pedido online' : 'Necesitas contratar Movistar Plus+ para poder añadir este paquete a tu TV',
          msg: goToC2C ? [`Ponte en contacto gratis en el ${PHONE_900} y un asesor comercial te ayudará a resolver el problema.`] : [''],
          buttons: [
            goToC2C ? CALL_GENERIC_900 : {
              label: 'Configurar mi pack',
              link: URLS.PACK_CONFIG,
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'no se tiene oferta dependiente necesaria',
        },
      },
      DEFAULT_ERROR: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: goToC2C ? 'Lo sentimos, no podemos continuar con tu pedido online' : 'Para poder contratar este paquete de TV tienes que hacerlo a través del configurador de miMovistar',
          msg: goToC2C ? [`Ponte en contacto gratis en el ${PHONE_900} y un asesor comercial te ayudará a resolver el problema.`] : [''],
          buttons: [
            goToC2C ? CALL_GENERIC_900 : {
              label: 'Configurar mi pack',
              link: URLS.PACK_CONFIG,
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
